export default __webpack_public_path__ + "static/pod-metrics-8f64f424cb6f929ce1c83345ae1dc270.png";